import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssabilMenu } from 'src/app/assabil-kernel/models/entities/control-tables/assabil-menu';
import { AssabilMenuRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/assabil-menu-request';

@Component({
  selector: 'assabil-menu-list',
  templateUrl: './assabil-menu-list.component.html',
  styleUrls: ['./assabil-menu-list.component.scss']
})

export class AssabilMenuListComponent extends BasePage2<AssabilMenu> {


  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  assabilMenus: AssabilMenu[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "assabilMenu";
  }
  // ---------------------------------------------------

    
  // ---------------------------------------------------
  getRows(): AssabilMenu[] {
      return this.assabilMenus;
  }
  // ---------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: AssabilMenu): Promise<AssabilMenu> {
    let request: AssabilMenuRequest = new AssabilMenuRequest(this.controlTablesService.getUserInfo());
    request.assabilMenu = row;
    return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  new(){
      let entity : AssabilMenu = new AssabilMenu();
      entity.inserted = true;
      entity.edit = true;
      this.assabilMenus.push(entity);
      this.assabilMenus = [...this.assabilMenus];
    }
//----------------------------------------------------------------------

        
//----------------------------------------------------------------------
  loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.assabilMenus = result;
    })
  }
  // ---------------------------------------------------

}